import { render } from "./LandingUserRegistration.vue?vue&type=template&id=643d935e&scoped=true&lang=pug"
import script from "./LandingUserRegistration.vue?vue&type=script&lang=js"
export * from "./LandingUserRegistration.vue?vue&type=script&lang=js"

import "./LandingUserRegistration.vue?vue&type=style&index=0&id=643d935e&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-643d935e"]])

export default __exports__